import { app } from '@/main';
import SellCoins from '@/views/SellCoins/SellCoins.vue';
import RevenueReports from '@/views/SellCoins/RevenueReports/RevenueReports.vue';

import flagKeys from '@/constants/flagKeys';
import { sellCoinsValidator } from '@/router/validators/navbar';
import { IBusinessType } from '@/models/business';

import { Route } from '../route.model';

const hideFromMenu = () => {
  return app.$store.getters['flags/getFlags'].includes(
    flagKeys.coinRevenueOverview
  );
};

const sellCoins = new Route('/sell-coins', 'sell_coins', SellCoins, {
  isResponsive: flagKeys.responsiveDashboard,
  requiresAuth: true,
  hideFromMenu,
  validator: () => sellCoinsValidator(),
  navbar: {
    name: 'Sell Coins', // TODO apply i18n
    icon: 'sell-coins',
    description:
      'Sell your own digital currency. Members can use or gift these Coins.'
  },
  pageView: {
    eventLabel: 'Sell Coins'
  },
  feature: {
    type: IBusinessType.INSTORE
  }
});

const sellCoinsV2 = new Route(
  '/overview-sell-coins',
  'overview_sell_coins',
  SellCoins,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.coinRevenueOverview,
    validator: () => sellCoinsValidator(),
    navbar: {
      name: 'Sell Coins',
      icon: 'sell-coins',
      description:
        'Overview of campaigns, Coin sales performance, and total earnings.'
    },
    pageView: {
      eventLabel: 'Sell Coins'
    },
    feature: {
      type: IBusinessType.INSTORE
    }
  }
);

const revenueReports = new Route(
  '/revenue-reports',
  'revenue_reports',
  RevenueReports,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    flag: flagKeys.coinRevenueOverview,
    validator: () => sellCoinsValidator(),
    navbar: {
      description:
        'Access detailed reports on revenue generated through Coin sales.'
    },
    pageView: {
      eventLabel: 'Sell Coins Revenue Reports'
    }
  }
);

export { sellCoins, sellCoinsV2, revenueReports };
export default sellCoins;
